module.exports = __webpack_public_path__ + "static/media/car.e02b26f9.png";